import { Injectable } from '@angular/core';
import {AccordionComponent} from "./accordion.component";

@Injectable({
  providedIn: 'root'
})
export class AccordionService {

  private _activeAccordions: Map<number, AccordionComponent[]> = new Map<number, AccordionComponent[]>();
  constructor() { }

  addAccordion(component: AccordionComponent): void {
    const accordionSet = this._activeAccordions.get(component.id);

    if(accordionSet) {
      accordionSet.push(component);
      this._activeAccordions.set(component.id, accordionSet);
    } else {
      this._activeAccordions.set(component.id, [component]);
    }
  }

  closeSiblings(component: AccordionComponent): void {
    const accordionSet = this._activeAccordions.get(component.id);

    if(accordionSet) {
      accordionSet.forEach((el) => {
        if(el.isOpened && component.idx !== el.idx) {
          el.toggleState(false);
        }
      })
    }
  }

  removeAccordion(component: AccordionComponent): void {
    let accordionSet = this._activeAccordions.get(component.id);

    if(accordionSet) {
      accordionSet = accordionSet.filter((el) => el.idx !== component.idx);

      if(accordionSet.length === 0) {
        this._activeAccordions.delete(component.id);
      } else {
        this._activeAccordions.set(component.id, accordionSet);
      }
    }
  }
}
